var _g, _path, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkforceSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 120,
    viewBox: "0 0 110 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_472_9904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4975 107.956C50.4722 109.093 52.712 109.691 54.9921 109.691C57.2723 109.691 59.5122 109.093 61.4869 107.956L93.5054 89.522C95.4799 88.3849 97.1195 86.7495 98.2596 84.78C99.3996 82.8105 99.9998 80.5764 100 78.3023L100 41.3882C99.9998 39.1141 99.3996 36.88 98.2596 34.9105C97.1195 32.9411 95.4799 31.3056 93.5054 30.1685L61.4868 11.735C59.5122 10.5978 57.2723 9.99911 54.9921 9.99911C52.712 9.99911 50.4722 10.5978 48.4975 11.735L16.4947 30.1685C14.5202 31.3056 12.8806 32.9411 11.7405 34.9105C10.6005 36.88 10.0002 39.1141 9.99999 41.3883L10 78.3023C10.0002 80.5765 10.6005 82.8106 11.7405 84.78C12.8806 86.7495 14.5202 88.3849 16.4947 89.522L48.4975 107.956Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4799 43.6824C72.6045 42.9954 72.0045 42.3953 71.3174 42.52L55.1095 45.4611C54.3157 45.6051 54.0105 46.5816 54.581 47.1521L57.6552 50.2263C57.5426 50.275 57.4371 50.3453 57.3451 50.4373L34.6886 73.0938C34.2981 73.4843 34.2981 74.1175 34.6886 74.508L40.4444 80.2638C40.8349 80.6543 41.4681 80.6543 41.8586 80.2638L64.5151 57.6073C64.6071 57.5153 64.6775 57.4098 64.7261 57.2972L67.8477 60.4189C68.4183 60.9894 69.3947 60.6842 69.5388 59.8903L72.4799 43.6824Z",
    fill: "url(#paint0_linear_472_9904)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3761 47.5118C33.9855 47.1213 33.9855 46.4881 34.3761 46.0976L40.1318 40.3418C40.5224 39.9513 41.1555 39.9513 41.5461 40.3418L44.0484 42.8442L41.7213 45.1713L42.5882 46.0381L44.9153 43.711L47.9491 46.7448L46.4888 48.2051L47.3556 49.0719L48.8159 47.6116L51.8498 50.6455L49.5227 52.9726L50.3895 53.8394L52.7166 51.5123L55.7504 54.5461L54.2901 56.0064L55.1569 56.8732L56.6172 55.413L59.6511 58.4468L57.324 60.7739L58.1908 61.6407L60.5179 59.3136L63.5517 62.3475L62.0914 63.8077L62.9583 64.6745L64.4185 63.2143L67.4524 66.2481L65.1253 68.5752L65.9921 69.442L68.3192 67.1149L71.353 70.1488L69.8928 71.609L70.7596 72.4759L72.2198 71.0156L74.4454 73.2412C74.8359 73.6317 74.8359 74.2648 74.4454 74.6554L68.6896 80.4112C68.2991 80.8017 67.6659 80.8017 67.2754 80.4112L34.3761 47.5118Z",
    fill: "url(#paint1_linear_472_9904)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_472_9904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4975 107.956C50.4722 109.093 52.712 109.691 54.9921 109.691C57.2723 109.691 59.5122 109.093 61.4869 107.956L93.5054 89.522C95.4799 88.3849 97.1195 86.7495 98.2596 84.78C99.3996 82.8105 99.9998 80.5765 100 78.3023L100 41.3883C99.9998 39.1141 99.3996 36.88 98.2596 34.9105C97.1195 32.9411 95.4799 31.3056 93.5054 30.1685L61.4868 11.735C59.5122 10.5978 57.2723 9.99911 54.9921 9.99911C52.712 9.99911 50.4722 10.5978 48.4975 11.735L16.4947 30.1685C14.5202 31.3056 12.8806 32.9411 11.7405 34.9105C10.6005 36.88 10.0002 39.1141 9.99999 41.3883L10 78.3023C10.0002 80.5765 10.6005 82.8106 11.7405 84.78C12.8806 86.7495 14.5202 88.3849 16.4947 89.522L48.4975 107.956Z",
    fill: "#2468FF",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2373 107.522L61.2374 107.522L93.2559 89.0887C95.1544 87.9954 96.7308 86.4229 97.8268 84.5295C98.9228 82.6361 99.4998 80.4884 99.5 78.3022L99.5 41.3883C99.4998 39.2021 98.9228 37.0544 97.8268 35.161C96.7308 33.2676 95.1544 31.6952 93.2559 30.6018L61.2374 12.1683L61.2373 12.1683C59.3386 11.0748 57.1847 10.4991 54.9921 10.4991C52.7996 10.4991 50.6457 11.0748 48.7471 12.1683L16.7443 30.6018L16.4947 30.1685L16.7442 30.6018C14.8457 31.6952 13.2693 33.2676 12.1733 35.161C11.0772 37.0544 10.5002 39.2021 10.5 41.3883L10.5 78.3022C10.5 78.3022 10.5 78.3023 10.5 78.3023C10.5002 80.4884 11.0773 82.6361 12.1733 84.5295C13.2693 86.4229 14.8457 87.9954 16.7442 89.0887L16.7443 89.0887L48.7471 107.522C48.7471 107.522 48.7471 107.522 48.7471 107.522C50.6458 108.616 52.7996 109.191 54.9921 109.191C57.1847 109.191 59.3386 108.616 61.2373 107.522Z",
    stroke: "#2468FF",
    strokeOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_472_9904",
    x: 0,
    y: 0,
    width: 110,
    height: 119.691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_472_9904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_472_9904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_472_9904",
    x: 0,
    y: 0,
    width: 110,
    height: 119.691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_472_9904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_472_9904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_472_9904",
    x1: 82.8689,
    y1: 47.6008,
    x2: 45.7447,
    y2: 32.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#927FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_472_9904",
    x1: 75.2359,
    y1: 53.1873,
    x2: 53.6405,
    y2: 77.7455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010305",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931528,
    stopColor: "#010305"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkforceSelected);
export default __webpack_public_path__ + "static/media/workforce_selected.5c6f3d24ef6e7095ce539074221ce456.svg";
export { ForwardRef as ReactComponent };